<bn-loading-overlay></bn-loading-overlay>
<h5>Notas</h5>
<div class="container" *ngIf="pesquisaForm">
    <form [formGroup]="pesquisaForm" class="mt-3 mx-auto">

        <div class="row">
            <div class="col">
                <h3>Filtros de pesquisa</h3>
            </div>

            <div class="col-auto" *ngIf="podeCadastrarNota">
                <button class="btn btn-primary no-margin" type="button" [routerLink]="['/notas']"
                    ngbTooltip="Tela para cadastro de Nota."><i class="fa fa-file-signature">
                    </i> Cadastrar nova Nota
                </button>
            </div>

            <div class="col-auto">
                <button type="button" class="btn btn-light" (click)="limpar()">Limpar</button>
            </div>

            <div class="col-auto">
                <button #focusableSubmit type="button" class="btn btn-success no-margin" (keydown.enter)="buscar()"
                    (click)="buscar()" [disabled]="!pesquisaForm.valid">Pesquisar
                </button>
            </div>
        </div>

        <div class="row">
            <div class="col-md-9 bn-form-group">
                <label class="form-label">Agente Financeiro:</label>
                <select class="form-select" name="agenteFinanceiro" ngDefaultControl
                    formControlName="agenteFinanceiro">
                    <option [ngValue]=null>Todos</option>
                    <option *ngFor="let agente of agentesFinanceiros" [ngValue]="agente">{{ agente.nome }}
                    </option>
                </select>
            </div>
            <div class="col-md-3 bn-form-group">
                <label class="form-label">Estado:</label>
                <select class="form-select" name="estado" ngDefaultControl formControlName="estado">
                    <option [ngValue]=null>Todos</option>
                    <option *ngFor="let estado of estados" [ngValue]="estado.valor">{{ estado.descricao }}
                    </option>
                </select>
            </div>
        </div>

        <div class="row">
            <div class="col-md-3 bn-form-group">
                <label class="form-label">Tipo Operação/Sistema: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                        ngbTooltip="Sistema do contrato, constante dos Boletos de Cobrança enviados pelo BNDES, ou Crédito Livre."></i></label>
                <select class="form-select" name="classeOperacao" ngDefaultControl formControlName="classeOperacao">
                    <option [ngValue]='null'>Todos</option>
                    <option *ngFor="let classeOperacao of classesOperacao" [ngValue]="classeOperacao.codigo">{{
                        classeOperacao.nome }}
                    </option>
                </select>
            </div>
            <div class="col-md-4 bn-form-group">
                <label class="form-label">Id. externo operação: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                        ngbTooltip="Identificador do protocolo da operação informado pelo Agente Financeiro
                      (em operações Crédito Livre) ou o identificador de protocolo do BNDES Online (em operações de Repasse BNDES)."></i></label>
                <input class="form-control" name="idOperacaoExterno" ngDefaultControl
                    formControlName="idOperacaoExterno">
            </div>
            <div class="col-md-2 bn-form-group">
                <label class="form-label">Contrato: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                        ngbTooltip="Número do contrato, constante dos Boletos de Cobrança enviados pelo BNDES."></i></label>
                <input class="form-control" name="contratoRepasse" ngDefaultControl formControlName="contratoRepasse">
            </div>
        </div>
    </form>
</div>


<ng-template #desativacao>
    <h5>Deseja realmente desativar a nota abaixo ?</h5>
    <div class="row">
        <div class="bn-form-group col-md-12">
            <label for="agenteNotaDesativacao"><b>Agente</b></label>
            <input readonly type="text" class="form-control" id="agenteNotaDesativacao" name="agenteNotaDesativacao"
                value="{{ retornaAgenteFinanceiro(notaDesativando.idAgenteFinanceiro).nome }}" />
        </div>
    </div>
    <div class="row">
        <div class="bn-form-group col-md-6">
            <label for="classeOperacaoNotaDesativacao"><b>Tipo Operação/Sistema</b></label>
            <select name="classeOperacaoNotaDesativacao" id="classeOperacaoNotaDesativacao" class="form-select"
                [ngValue]="notaDesativando.sistemaRepasse" disabled>
                <option *ngFor="let classeOperacao of classesOperacao" [ngValue]="classeOperacao.codigo">{{
                    classeOperacao.nome }}
                </option>
            </select>

        </div>
        <div class="bn-form-group col-md-6">
            <label for="dataPublicacao"><b>Publicado em</b></label>
            <input readonly type="text" class="form-control" id="dataPublicacao" name="dataPublicacao"
                value="{{ notaDesativando.dataEnvio | date: 'dd/MM/yyyy HH:mm' }}" />

        </div>
        <div class="bn-form-group col-md-12">
            <label for="nomeUsuarioEnvio"><b>Enviado por </b></label>
            <input readonly type="text" class="form-control" id="nomeUsuarioEnvio" name="nomeUsuarioEnvio" class="form-control"
                value="{{ notaDesativando.nomeUsuarioEnvio }}" />
        </div>

        <div class="bn-form-group col-md-12">
            <label for="notaDesativacaoMensagem"><b>Mensagem</b></label>
            <textarea name="notaDesativacaoMensagem" id="notaDesativacaoMensagem" rows="3" class="form-control" disabled
                value="{{ notaDesativando.mensagem }}"></textarea>
        </div>

    </div>
</ng-template>
<ng-template #desativacaoBotoes>
    <button class="btn btn-default" (click)="cancelaDesativacao()">Cancelar</button>
    <button class="btn btn-primary" (click)="confirmaDesativacao()">Confirmar</button>
</ng-template>


<app-notas-listagem 
    [notas]="notas" 
    [podeCadastrarNota]="podeCadastrarNota"
    [dataHoraResultado]="dataHoraResultado"
    [atributosPaginacao]="atributosPaginacaoComponenteListagem" 
    *ngIf="pesquisado"
    [hidden]="esconderPesquisa"
    (aoRequererDesativacao)="desativacaoNota($event)"
    (aoMudarPagina)="mudancaPagina($event)"
    >
</app-notas-listagem>